/**
 * **NOTE** The styles in this file are a direct copy of the styles found at:
 * `src/modules/templateEditor/EditWebPush/preview/`.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

import styled from 'styled-components';
import { fonts, fontSizes, fontWeights, spacing, subtleShadow } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const MessagePreview = styled.div`
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: stretch;
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;
`;

export const MessageContainer = styled.div`
    background-color: rgba(255, 255, 255, 0.9);
    display: grid;
    grid-column-gap: ${pxToRem(20)};
    grid-row-gap: ${pxToRem(12)};
    grid-template-areas: 
        'title now'
        'content media';
    flex-direction: column;
    border-radius: ${fontSizes.s18};
    font-weight: ${fontWeights.regular};
    padding: ${pxToRem(25)};
    margin: ${pxToRem(24)} ${pxToRem(18)};
    word-break: break-word;
    grid-template-columns: 1fr 60px;
    ${subtleShadow}
`;

export const MessageTitle = styled.div`
    grid-area: title;
    font-family: ${fonts.sfPro};
    font-weight: ${fontWeights.semiBold};
    font-size: ${fontSizes.s20};
    line-height: ${spacing.base};
    word-break: break-word;
    white-space: break-spaces;
    padding-bottom: 0;
`;

export const MessageContent = styled.div`
    grid-area: content;
    font-family: ${fonts.sfPro};
    font-size: ${fontSizes.s18};
    font-weight: ${fontWeights.light};
    line-height: ${pxToRem(21)};
    word-break: break-word;
    padding-top: 0;
    display: flex;
    flex-direction: column;
    column-gap: ${spacing.threeEights};
    white-space: pre-wrap; 
`;

export const MessageMedia = styled.div`
    display: flex;
    grid-area: media;
    align-self: center;
    background-size: cover;
    height: 54px;
    width: 54px;
    justify-self: 'end';
    border-radius: ${spacing.threeEights};
`;
